import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect, useMemo, useState } from "react";
import classes from './style.module.scss'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { IMAGE_GEEKO_LTD } from "../../../../../../../constants";
import {FormattedMessage} from "react-intl";
import CountDown from "../../../../../../components/count-down";


const ProgressTip = props => {
    useStyles(classes)
    const { data, type, percent, mainColor } = props
    const { done, name } = data || {}

    const actualPx = (px) => {
        return (2 * px / 75 * 1) + 'rem'
    }

    const styleCfg = useMemo(() => {
        let obj = {}
        if(type == 'coupon'){
            obj.backgroundImage = !data?.done ? `url(${IMAGE_GEEKO_LTD}/chicme/20230214/pink.png)`: `url(${IMAGE_GEEKO_LTD}/chicme/20230214/red.png)`
            obj.backgroundSize = '100% 100%'
            obj.color = !data?.done ? mainColor: '#fff'
            // obj.right = actualPx(-10)
            obj.transform='translateX(-50%)'
            return obj
        } else {
            obj.background = !data?.done ? '#D4E6DF': '#2A845E'
            obj.color = !data?.done ? mainColor: '#fff'
            obj.borderRadius = actualPx(2)
            if(percent < 40){
                obj.left = actualPx(-10)
            } else {
                obj.right = actualPx(-10)
            }
            return obj
        }
    }, [type, data, percent])

    return (
        <div className={`${classes.ProgressTip}`} style={styleCfg}>
            <span>{name}</span>
        </div>
    )
}

const CountDownPart = props => {
    useStyles(classes)
    const {date} = props
    const now = Date.now();
    const diff = date - now;
    const day = Math.floor(diff / (1000 * 60 * 60 * 24))
    return day>2?"":<div className={classes.CountDownBox}>
        <span className={classes.Expiresin}><FormattedMessage id="expires_in" defaultMessage="Expires in" /></span>
        <CountDown
            showDay={true}
            showHour={true}
            offset={diff}
            numberClass={classes.numberClass}
        />
        {/*<span className={classes.CountDownText}><FormattedMessage id="ends_today" defaultMessage={"ends today"}/></span>*/}
    </div>
}
// 1. 基础物流凑免邮
// 2. 基础物流和高级物流两档凑免邮
// 3. 优惠券凑满减

// 数据格式 progress:[{name:'***', done:false},{name:'***1', done: false}]

const ProgressLine = props => {
    useStyles(classes)

    const { type, promoteMsg } = props
    const { progress } = promoteMsg || {}
    const [progressWidth, setProgressWidth] = useState('10')

    const mainColor = useMemo(() => {
        return type == 'coupon' ? '#E96060': '#FFFFFF'
    }, [type])

    const formateMsg = useMemo(() => {
        // let msg = "<font color=\"#222222\">¡Compre<strong> S$46.66 </strong>más para disfrutar del <strong>ENVÍO ESTÁNDAR GRATIS</strong> !</font>"
        let msg = promoteMsg?.msg || ''
        if(type == 'coupon'){
            msg = msg.replace(/<strong>/g, `<strong style="color: ${mainColor}";>`)
        }else{
            msg = msg.replace(/<strong>/g, `<strong style="color: ${mainColor}";>`)
        }

        return msg
    }, [mainColor, promoteMsg])

    const calculateProgressWidth = (progress) => {
        if(!progress?.length)return '10'
        if(type == 'shipping'){
            let progressNow = 1, part = Number(progress.length) + 1, progressAdd = 0
            progress?.forEach((p) => {
                if(p?.done){
                    progressNow += 1
                }
                if(p?.phaseCompletionRatio){
                    progressAdd += p?.phaseCompletionRatio
                }
            })
            if(progressNow == 1){
                // return (((1 / part) * 100) - 10)
                if(part == 2){
                    return (progress?.[0]?.['phaseCompletionRatio'] || 0.1) * 100 * 0.7
                } else {
                    return (progress?.[0]?.['phaseCompletionRatio'] || 0.1) * 100 * (1 / part)
                }
            } else if(progressNow == part){
                return '100'
            } else {
                // return (((progressNow / part) * 100) - 10)
                return progressAdd * 100 * (1 / part)
            }
        } else {
            if(progress?.[0]?.done){
                return '100'
            } else {
                return (progress?.[0]?.['phaseCompletionRatio'] || 0.1) * 100 * 0.7
            }
        }
    }

    useEffect(() => {
        let num = calculateProgressWidth(progress)
        setProgressWidth(num)
    }, [progress])

    const showTipIndex = useMemo(() => {
        let indexReturn = 0
        if(progress?.length == 1 || !progress?.[0]?.done){
            return indexReturn
        } else {
            progress?.forEach((p, index) => {
                if(indexReturn == 0 && index != 0 && !p?.done && progress?.[index - 1]?.done){
                    indexReturn = index
                }
            })
            if(indexReturn == 0){
                return progress?.length - 1
            } else {
                return indexReturn
            }
        }
    }, [progress])


    return (
        <div className={`${classes.ProgressLineBox} ${type == 'coupon' ?classes.CouponBoxBackground:classes.ShippingBoxBackground}`}>
            <div className={classes.ProgressMsg} dangerouslySetInnerHTML={{__html: formateMsg}}></div>

            <div className={classes.LineBox}>
                <div className={`${classes.MainLine} ${type == 'coupon' ? classes.CouponCfg: classes.ShippingCfg}`}>
                    <div className={`${type == 'shipping'?classes.ShippingProgressLine:classes.ProgressLine}`} style={{width: `${progressWidth}%`, backgroundColor: mainColor}}></div>

                    {
                        type == 'shipping' ?
                        <React.Fragment>
                            {/* 免邮档位不确定数量 */}
                            {
                                progress?.map((pro, index) => {
                                    const styleLeft = progress?.length == 1 ? '70':
                                                    ((1 / (progress?.length + 1)) * (index + 1) * 100)
                                    return <div className={`${classes.ProgressTipBox} ${classes.ProgressShipping} ${pro?.done ? classes.ShippingDone: ''}`} key={index} style={{left: styleLeft+'%'}}>
                                        {
                                            /*
                                            pro?.done ?
                                            <Iconfont className={classes.TipIcon} style={{color: '#fff'}}>&#xe6f0;</Iconfont>:
                                            <Iconfont className={classes.TipIcon} style={{color: mainColor}}>&#xe70c;</Iconfont>
                                             */
                                        }
                                        {
                                            /*
                                            index == showTipIndex &&
                                            <React.Fragment>
                                                <div className={classes.PositionBox} style={{backgroundColor: pro?.done ? '#2A845E': '#D4E6DF' }}></div>
                                                <ProgressTip data={pro} type={type} percent={styleLeft} mainColor={mainColor}/>
                                            </React.Fragment>
                                             */
                                        }
                                    </div>
                                })
                            }
                        </React.Fragment>:
                        <React.Fragment>
                            {/* 优惠券目前固定显示一档 */}
                            <div className={`${classes.ProgressTipBox} ${classes.CouponPosition} ${progress?.[0]?.done ? classes.CouponDone: ''}`}>
                                {
                                 /*
                                    progress?.[0]?.done ?
                                    <Iconfont className={classes.TipIcon} style={{color: '#fff'}}>&#xe6f0;</Iconfont>:
                                    <Iconfont className={classes.TipIcon} style={{color: mainColor}}>&#xe70c;</Iconfont>
                                  */
                                }
                                {/*<ProgressTip data={progress?.[0]} type={type} percent={70} mainColor={mainColor}/>*/}
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
            {
                promoteMsg.couponEndDate&& <CountDownPart
                    date={promoteMsg.couponEndDate}
                />
            }

        </div>
    )
}

export default ProgressLine